import React from 'react'

function AnotherPage() {
  return (
    <div>AnotherPage</div>
  )
}

export default AnotherPage